import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// Updated Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';               // For Employees
import PhoneIcon from '@mui/icons-material/Phone';               // For Calls
import FindInPageIcon from '@mui/icons-material/FindInPage';       // For Findings
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);

  // Split the pathname into segments.
  const segments = location.pathname.split("/");
  // Given the URL: /pentest/vishing/calls/132, the pentest id is at index 4.
  const pathParts = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
  const pentest_id = pathParts[pathParts.length - 1];

  // Determine selected tab based on URL
  useEffect(() => {
    if (location.pathname.match(/^\/pentest\/vishing\/dashboard\/\d+$/)) {
      setSelectedTab(0);
    } else if (location.pathname.match(/^\/pentest\/vishing\/employees\/\d+$/)) {
      setSelectedTab(1);
    } else if (location.pathname.match(/^\/pentest\/vishing\/calls\/\d+$/)) {
      setSelectedTab(1);
    } else if (location.pathname.match(/^\/pentest\/vishing\/findings\/\d+$/)) {
      setSelectedTab(2);
    } else if (location.pathname.match(/^\/pentest\/vishing\/report\/(pentest|executive|attestation)\/\d+$/)) {
      setSelectedTab(3);
    }else {
      setSelectedTab(0); // Default to Dashboard if no match
    }
  }, [location.pathname]);

  // Handle tab change and navigate to the corresponding route
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    switch (newValue) {
      case 0:
        navigate(`/pentest/vishing/dashboard/${pentest_id}`);
        break;
      case 1:
        navigate(`/pentest/vishing/calls/${pentest_id}`);
        break;
      case 2:
        navigate(`/pentest/vishing/findings/${pentest_id}`);
        break;
      default:
        break;
    }
  };

  const [reportAnchorEl, setReportAnchorEl] = useState(null);
  // Reports dropdown handlers
  const handleReportClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setReportAnchorEl(e.currentTarget);
  };
  const handleReportClose = () => setReportAnchorEl(null);
  const handleReportItem = type => {
    setReportAnchorEl(null);
    setSelectedTab(5);
    navigate(`/pentest/vishing/report/${type}/${pentest_id}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '10px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Pentest
        </Typography>
      </Box>

      {/* Navigation Tabs */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="Navigation Tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab icon={<DashboardIcon />} label="Dashboard" />
        <Tab icon={<PhoneIcon />} label="Calls" />
        <Tab icon={<FindInPageIcon />} label="Findings" />
        <Tab
          icon={<DescriptionIcon />}
          label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Report <ArrowDropDownIcon fontSize="small" />
            </div>
          }
          onClick={handleReportClick}
        />
      </Tabs>

      {/* Reports Menu */}
      <Menu
        anchorEl={reportAnchorEl}
        open={Boolean(reportAnchorEl)}
        onClose={handleReportClose}
      >
        <MenuItem onClick={() => handleReportItem('pentest')}>
          <DescriptionIcon style={{ marginRight: 8 }} /> Pentest Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('executive')}>
          <AssessmentIcon style={{ marginRight: 8 }} /> Executive Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('attestation')}>
          <EmojiEventsIcon style={{ marginRight: 8 }} /> Attestation
        </MenuItem>
      </Menu>

    </Box>
  );
}

export default Nav;
